import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Vérification synchrone pour éviter les blocages
  // isAuthenticated() est synchrone et vérifie uniquement les tokens locaux
  try {
    const isAuth = authService.isAuthenticated();

    if (!isAuth) {
      // Redirect to login with return URL
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  } catch (error) {
    console.error('❌ Auth guard error:', error);
    router.navigate(['/auth/login']);
    return false;
  }

  // Vérifier l'accès selon la route
  const url = state.url;

  // ============================================
  // Gestion des routes Manager (/manager/*)
  // ============================================
  if (url.startsWith('/manager')) {
    // Vérifier si l'utilisateur a les permissions manager
    if (!authService.canAccessManager()) {
      // Pas manager, rediriger vers le dashboard commercial
      router.navigate(['/dashboard']);
      return false;
    }

    // Les commerciaux ne doivent pas accéder aux routes manager
    if (authService.canAccessCommercialDashboard() && !authService.canAccessManager()) {
      router.navigate(['/dashboard']);
      return false;
    }

    // Manager autorisé, laisser passer
    return true;
  }

  // ============================================
  // Gestion des routes Dashboard Commercial (/dashboard)
  // ============================================
  if (url.startsWith('/dashboard') && !url.startsWith('/manager')) {
    // Les managers ne doivent pas accéder au dashboard commercial
    // EXCEPTION : Les routes clients, shippings et orders sont partagées
    const isSharedRoute = url.startsWith('/dashboard/clients') ||
      url.startsWith('/dashboard/shippings') ||
      url.startsWith('/dashboard/orders');

    if (authService.canAccessManager() && !authService.canAccessCommercialDashboard() && !isSharedRoute) {
      // C'est un manager sur une route non partagée, rediriger vers /manager/dashboard
      router.navigate(['/manager/dashboard']);
      return false;
    }

    // Vérifier que l'utilisateur a bien les permissions commerciales (Sauf si route partagée)
    if (!authService.canAccessCommercialDashboard() && !isSharedRoute) {
      // Pas commercial, rediriger vers la route par défaut
      const defaultRoute = authService.getDefaultRoute();
      router.navigate([defaultRoute]);
      return false;
    }

    // Commercial autorisé, laisser passer
    return true;
  }

  return true;
};

